module.exports = __webpack_public_path__ + "img/selected5-min.d1b5f336.png";